/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seller_Dashboard_WelcomeInputs */

const en_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hey, ${i?.name} 👋`)
};

const es_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hola, ${i?.name} 👋`)
};

const fr_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salut, ${i?.name} 👋`)
};

const de_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hallo, ${i?.name} 👋`)
};

const ja_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`こんにちは、${i?.name}さん 👋`)
};

const zh_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你好，${i?.name} 👋`)
};

const ar_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مرحباً، ${i?.name} 👋`)
};

const id_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai, ${i?.name} 👋`)
};

const it_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ciao, ${i?.name} 👋`)
};

const ru_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Привет, ${i?.name} 👋`)
};

const pt_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Olá, ${i?.name} 👋`)
};

const ko_seller_dashboard_welcome = /** @type {(inputs: Seller_Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`안녕하세요, ${i?.name}님 👋`)
};

/**
* | output |
* | --- |
* | "Hey, {name} 👋" |
*
* @param {Seller_Dashboard_WelcomeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_welcome = /** @type {((inputs: Seller_Dashboard_WelcomeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_WelcomeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_welcome(inputs)
	if (locale === "es") return es_seller_dashboard_welcome(inputs)
	if (locale === "fr") return fr_seller_dashboard_welcome(inputs)
	if (locale === "de") return de_seller_dashboard_welcome(inputs)
	if (locale === "ja") return ja_seller_dashboard_welcome(inputs)
	if (locale === "zh") return zh_seller_dashboard_welcome(inputs)
	if (locale === "ar") return ar_seller_dashboard_welcome(inputs)
	if (locale === "id") return id_seller_dashboard_welcome(inputs)
	if (locale === "it") return it_seller_dashboard_welcome(inputs)
	if (locale === "ru") return ru_seller_dashboard_welcome(inputs)
	if (locale === "pt") return pt_seller_dashboard_welcome(inputs)
	return ko_seller_dashboard_welcome(inputs)
});